import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'II. COMPOSIZIONE BENEFICIARI ACCOMPAGNATI – CONDIZIONI DI SALUTE E AUTONOMIA ',
    tooltip: 'Il grafico rappresenta la composizione dei beneficiari effettivi per condizioni di salute e livello di autonomia.',
    type: 'column',
    categories: [
        'Percentuale di beneficiari anziani in condizioni di salute scarse o pessime sul totale dei beneficiari anziani accompagnati',
        'Percentuale di beneficiari anziani per i quali le condizioni di salute sono limitanti'
    ],
    series: [
        {
            color: COLORS.blue,
            name: 'Data',
            data: getIndicators(submissions)
        },
    ],
});